import { render, staticRenderFns } from "./DataCustomer.vue?vue&type=template&id=27f72c40&scoped=true&"
import script from "./DataCustomer.vue?vue&type=script&lang=js&"
export * from "./DataCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DataCustomer.vue?vue&type=style&index=0&id=27f72c40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f72c40",
  null
  
)

export default component.exports